<div class="item-container-header bold" *ngIf="title">{{ title }}</div>
<ng-content></ng-content>
